import { render } from "./NotFound.vue?vue&type=template&id=5908ca42&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=ts"
export * from "./NotFound.vue?vue&type=script&lang=ts"

import "./NotFound.vue?vue&type=style&index=0&id=5908ca42&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5908ca42"

export default script